import { IconDefinition } from "./types";

const star: IconDefinition = {
  iconName: "star",
  width: 16,
  height: 16,
  svgPathData:
    "M8 13.267L3.056 16 4 10.211l-4-4.1 5.528-.844L8 0l2.472 5.267L16 6.11l-4 4.1.944 5.789z",
  iconType: "fill",
};

export { star };
